import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../components/Header";

import previous from "../components/assets/back.png";
import { useProductsContext } from "../contexts/products";
import { useEffect } from "react";
import { Container } from "../components/Container";
import { Spinner } from "../components/Spinner";
import { CartItem, useHeyFlowLeadContext } from "../contexts/heyFlowLead";
import { Footer } from "../components/Footer";
import { Popup } from "../components/Popup";
import { CremationProductDetails } from "../components/CremationProductDetails";
import { TCremation } from "../utils/api";

export function CremationUpsell() {
  const { heyflowId } = useParams();
  const navigate = useNavigate();

  const { setHeyflowId, changeCartItem, value } = useHeyFlowLeadContext();
  const { asyncProduct: asyncEizen } = useProductsContext();
  const { asyncProduct: asyncSammeln } = useProductsContext();
  const { asyncProduct: asynPremium } = useProductsContext();

  const asyncEizenProductFetch = asyncEizen.fetch;
  const asyncSammelnProductFetch = asyncSammeln.fetch;
  const asyncPremiumProductFetch = asynPremium.fetch;

  const sammelnProductId = 27448;
  const eizenProductId = 24936
  const premumProductId = 65854


  const eizenProduct =
    heyflowId !== undefined ? asyncEizen.getValue(heyflowId, `${eizenProductId}`) : undefined;

  const sammelnProduct =
    heyflowId !== undefined ? asyncSammeln.getValue(heyflowId, `${sammelnProductId}`) : undefined;


  const premumProduct =
    heyflowId !== undefined ? asynPremium.getValue(heyflowId, `${premumProductId}`) : undefined;



  useEffect(() => {
    if (heyflowId !== undefined) {
      asyncEizenProductFetch(heyflowId, eizenProductId.toString());
      asyncSammelnProductFetch(heyflowId, sammelnProductId.toString());
      asyncPremiumProductFetch(heyflowId, premumProductId.toString());
    }
  }, [heyflowId, asyncEizenProductFetch, asyncSammelnProductFetch]);


  useEffect(() => {
    console.log("Heyflow ID in CremationUpsell:", heyflowId);
    setHeyflowId(heyflowId);
  }, [setHeyflowId, heyflowId]);


  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1">
        <Container className="flex-1">
          <button type="button" onClick={() => navigate(-1)} className="flex items-center">
            <img src={previous} alt="previous" className="w-7"></img>
            <span className="text-base pl-2">Zurück zur Auswahl</span>
          </button>

          {eizenProduct && sammelnProduct && premumProduct && value !== undefined ? (
            <CremationProductDetails
              addItem={(item: CartItem, _: boolean, weight: string, cremation: TCremation) => {
                changeCartItem(item, 0, cremation, weight);
                navigate(-1);
              }}
              sammeln={sammelnProduct}
              eizen={eizenProduct}
              preSelectedVariationId={value.cart[0]?.variationId}
              preselectedProductId={value.cart[0]?.productId}
              isCartItem={true}
              premium={premumProduct}
            ></CremationProductDetails>
          ) : (
            <div className="flex flex-col items-center py-10">
              <Spinner size="large"></Spinner>
              <div className="text-neutral-600 mt-10">Produktinformationen laden</div>
            </div>
          )}
        </Container>
      </div>
      <Footer></Footer>
      <Popup />
    </div>
  );
}
